export default __webpack_public_path__ + "5a66ec3bf9d3984993c6c1eefdca2ebf.png";